import ClearIcon from '@mui/icons-material/Clear'
import DeleteIcon from '@mui/icons-material/Delete'
import type { Theme } from '@mui/material'
import { Button, IconButton } from '@mui/material'
import { styled } from '@mui/material/styles'
import { isString } from 'lodash'
import type { CSSProperties, JSX } from 'react'
import React from 'react'
import { useTranslation } from 'react-i18next'

const dangerButtonStyles = (theme: Theme) => ({
  backgroundColor: theme.palette.error.main,
  borderRadius: `${theme.tokens.btnRadius}px !important`,
  color: '#ffffff',
  '&:hover': {
    backgroundColor: theme.palette.error.light
  }
})

const StyledButton = styled(Button)(({ theme }) => dangerButtonStyles(theme))

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  ...dangerButtonStyles(theme),
  borderRadius: '15%'
}))

type YisDangerButtonProps = {
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  dangerType?: 'close' | 'delete' | 'clear'
  text?: string | JSX.Element
  component?: React.ReactNode
  style?: CSSProperties
  fullWidth?: boolean
  endIcon?: JSX.Element
  title?: string
  size?: 'small' | 'medium' | 'large'
  disabled?: boolean
  onMouseEnter?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  onMouseLeave?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
}

export default function YisDangerButton ({
  onClick,
  dangerType,
  text,
  style,
  size = 'medium',
  ...props
}: YisDangerButtonProps) {
  const { t } = useTranslation()

  const btnText = isString(text) ? t(text) : text

  if (dangerType === 'close' || dangerType === 'delete' || dangerType === 'clear') {
    return <StyledIconButton
      title={dangerType}
      component="span"
      onClick={onClick}
      style={style}
      size={size}
      {...props}
    >
      {dangerType === 'close' && <ClearIcon fontSize={size} />}
      {dangerType === 'clear' && <ClearIcon fontSize={size} />}
      {dangerType === 'delete' && <DeleteIcon fontSize={size} />}
    </StyledIconButton>
  }

  return <StyledButton
    variant="contained"
    title={dangerType}
    component="span"
    onClick={onClick}
    style={style}
    {...props}
  >
    {text ? btnText : ''}
  </StyledButton>
}
